import React from 'react'
import styled from 'styled-components';
import { Login } from './Login';                                     // Login component


const Styles = styled.div`
    .h2 {
        position: center;
        color: #fff;
    }
`;

export const Home = () => (
    <Styles>
        <Login history={[]}/>
    </Styles>
)
